(() => {
  const initializeVariantMetafields = () => {
    const dataScript = document.querySelector(
      '#variant-metafields-data'
    );

    if (!dataScript) {
      return;
    }

    let variantData = {};

    try {
      variantData = JSON.parse(
        dataScript.textContent || '{}'
      );
    } catch (error) {
      console.error(
        '[variant-metafields] JSON invalide.',
        error
      );

      return;
    }

    const normalizeId = id => {
      return String(id ?? '').split('/').pop();
    };

    const updateFields = variant => {
      const variantId = normalizeId(variant?.id);
      const values = variantData[variantId] || {};

      document
        .querySelectorAll('[data-variant-field]')
        .forEach(element => {
          const fieldName = element.dataset.variantField;
          const fieldType = element.dataset.variantFieldType;

          /*
           * Le poids utilise deux valeurs natives Shopify.
           */
         if (fieldName === 'weight') {
  const weightInGrams = Number(
    values.weight_grams
  );

  if (
    !Number.isFinite(weightInGrams)
    || weightInGrams <= 0
  ) {
    element.textContent = '';
    return;
  }

  const weightInKilograms = weightInGrams / 1000;

  const formattedWeight =
    new Intl.NumberFormat('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(weightInKilograms);

  element.textContent = `${formattedWeight} kg`;
  return;
}

          const value = values[fieldName] ?? '';

          /*
           * Origine et conditionnement sont des textes enrichis.
           */
          if (fieldType === 'richtext') {
            element.innerHTML = String(value);
          } else {
            element.textContent = String(value);
          }
        });
    };

    /*
     * Affichage initial.
     */
    updateFields({
      id: dataScript.dataset.initialVariantId
    });

    /*
     * Méthode principale Horizon.
     */
    document.addEventListener(
      'shopify:product:select',
      event => {
        if (
          !event.promise
          || typeof event.promise.then !== 'function'
        ) {
          return;
        }

        event.promise
          .then(({ variant }) => {
            if (!variant?.id) {
              return;
            }

            requestAnimationFrame(() => {
              updateFields(variant);
            });
          })
          .catch(error => {
            console.error(
              '[variant-metafields] Erreur de variante.',
              error
            );
          });
      }
    );

    /*
     * Solution complémentaire :
     * lecture directe de data-variant-id sur l'élément
     * modifié dans le composant Horizon.
     */
    document.addEventListener(
      'change',
      event => {
        const target = event.target;

        if (!target?.closest) {
          return;
        }

        const variantPicker = target.closest(
          'variant-picker'
        );

        if (!variantPicker) {
          return;
        }

        let selectedOption = target;

        if (target instanceof HTMLSelectElement) {
          selectedOption = target.options[
            target.selectedIndex
          ];
        }

        const variantId =
          selectedOption?.dataset?.variantId
          || target?.dataset?.variantId
          || '';

        if (variantId) {
          updateFields({
            id: variantId
          });
        }
      },
      true
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeVariantMetafields,
      { once: true }
    );
  } else {
    initializeVariantMetafields();
  }
})();